import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { AIServiceComponent } from './AIServiceComponent';
export const AIReconnectionConfig = {
  statusesForDisplaying: [AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.SUNSET, AppConnectionStatuses.UPCOMING_SUNSET],
  serviceComponent: AIServiceComponent
};